import { useState } from "react";
import { FONT, COLORS, GRADIENT } from "../styles";

const FIELDS = [
  { key: "balance_critical", label: "Balance Critical ($)", desc: "ACH bounce risk HIGH below this" },
  { key: "balance_warning", label: "Balance Warning ($)", desc: "Monitor daily below this" },
  { key: "coverage_critical_days", label: "Coverage Critical (days)", desc: "CRITICAL if balance covers fewer days" },
  { key: "stacking_warning_pct", label: "Stacking Warning (%)", desc: "WARNING if loan payments exceed this % of revenue" },
  { key: "stacking_high_positions", label: "High Stack Positions", desc: "FAIL if active positions reach this count" },
  { key: "stacking_moderate_positions", label: "Moderate Stack Positions", desc: "Moderate risk at this count" },
  { key: "low_balance_watch", label: "Low Balance Watch ($)", desc: "Show in low balance events below this" },
  { key: "default_days", label: "Default Analysis Days", desc: "Days of transactions to fetch" },
];

export default function SettingsModal({ settings, onSave, onClose }) {
  const [values, setValues] = useState({ ...settings });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (key, val) => { setValues((prev) => ({ ...prev, [key]: val })); setError(""); };

  const handleSave = async () => {
    for (const f of FIELDS) { const v = parseFloat(values[f.key]); if (isNaN(v) || v < 0) { setError(`Invalid value for ${f.label}`); return; } }
    setSaving(true);
    try { await onSave(values); onClose(); } catch (err) { setError(err.message); } finally { setSaving(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: FONT }}>
      <div style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 14, padding: 32, width: 500, maxHeight: "80vh", overflowY: "auto", boxShadow: "0 10px 40px rgba(0,0,0,0.15)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: COLORS.text }}>Alert Thresholds</div>
            <div style={{ fontSize: 13, color: COLORS.muted, marginTop: 2 }}>Configure risk analysis parameters</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: COLORS.dim, cursor: "pointer", fontSize: 20 }}>✕</button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {FIELDS.map((f) => (
            <div key={f.key}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                <label style={{ fontSize: 13, color: COLORS.textSecondary, fontWeight: 500 }}>{f.label}</label>
                <span style={{ fontSize: 11, color: COLORS.dim }}>{f.desc}</span>
              </div>
              <input type="number" value={values[f.key] || ""} onChange={(e) => handleChange(f.key, e.target.value)}
                style={{ width: "100%", background: COLORS.bg, border: `1px solid ${COLORS.border}`, borderRadius: 8, padding: "8px 12px", fontSize: 13, color: COLORS.text, outline: "none", fontFamily: FONT, boxSizing: "border-box" }} />
            </div>
          ))}
        </div>
        {error && <div style={{ background: COLORS.redLight, border: "1px solid #FECACA", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: COLORS.red, marginTop: 16, textAlign: "center" }}>{error}</div>}
        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
          <button onClick={onClose} style={{ flex: 1, background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: 8, padding: 10, fontSize: 13, color: COLORS.textSecondary, cursor: "pointer", fontFamily: FONT, fontWeight: 500 }}>Cancel</button>
          <button onClick={handleSave} disabled={saving} style={{ flex: 1, background: GRADIENT, border: "none", borderRadius: 8, padding: 10, fontSize: 13, fontWeight: 600, color: "#fff", cursor: saving ? "not-allowed" : "pointer", fontFamily: FONT, opacity: saving ? 0.5 : 1 }}>{saving ? "Saving..." : "Save Thresholds"}</button>
        </div>
      </div>
    </div>
  );
}
